'use strict';

/**
 * Verifica che la tipologia del parametro in input sia diversa da undefined
 * @param mixed
 * @returns {boolean}
 */
module.exports = function isDefined(mixed) {
    return typeof(mixed) !== 'undefined';
};
